// Module-level cost event bus. Processing functions emit here; the
// React shell subscribes via useCostLedger to accumulate per-session totals.

type Listener = (usd: number) => void;

const listeners = new Set<Listener>();

export function emitCost(usd: number): void {
  if (!usd || usd <= 0 || !Number.isFinite(usd)) return;
  listeners.forEach((fn) => {
    try { fn(usd); } catch { /* listener errors must not break callers */ }
  });
}

export function subscribeCost(fn: Listener): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}
